import { render, staticRenderFns } from "./GroupGradeBook.vue?vue&type=template&id=df7363b0&"
import script from "./GroupGradeBook.vue?vue&type=script&lang=js&"
export * from "./GroupGradeBook.vue?vue&type=script&lang=js&"
import style0 from "./GroupGradeBook.vue?vue&type=style&index=0&id=df7363b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports